<script>
    import { createPrompt } from '@/api/chatGPT.js';

    export default {
        computed: {
            isSave() {return this.$store.getters.IS_SAVE_PROMPT_ADD},
        },
        methods: {
            async save() {
                const response = await createPrompt(
                    this.$store.getters.PROMPT_DATA_ADD
                );
                if (response != null) {
                    this.$store.commit('PROMPTS_PUSH', response);
                    await this.close();
                }
            },
            async close() {
                this.$store.commit('IS_SHOW_PROMPT_ADD', false);
            }
        }
    }
</script>


<template>
    <button
        :disabled="isSave === false"
        class="button_blue_100"
        @click="save"
    >Create</button>
    <button
        class="button_blue_100 close_button mr_10"
        @click="close"
    >Close</button>
</template>